import React, { useState, useEffect, useCallback, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import {
  organizationApi,
  locationApi,
  departmentApi,
  userApi
} from '../api/services'
import toast, { Toaster } from 'react-hot-toast'

// ── tiny SVG icon set ─────────────────────────────────────────────────────────
const Icon = {
  Plus: p => (
    <svg
      {...p}
      fill='none'
      viewBox='0 0 24 24'
      strokeWidth={2}
      stroke='currentColor'
    >
      <path
        strokeLinecap='round'
        strokeLinejoin='round'
        d='M12 4.5v15m7.5-7.5h-15'
      />
    </svg>
  ),
  Pencil: p => (
    <svg
      {...p}
      fill='none'
      viewBox='0 0 24 24'
      strokeWidth={2}
      stroke='currentColor'
    >
      <path
        strokeLinecap='round'
        strokeLinejoin='round'
        d='M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931z'
      />
    </svg>
  ),
  Trash: p => (
    <svg
      {...p}
      fill='none'
      viewBox='0 0 24 24'
      strokeWidth={2}
      stroke='currentColor'
    >
      <path
        strokeLinecap='round'
        strokeLinejoin='round'
        d='M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0'
      />
    </svg>
  ),
  Chevron: p => (
    <svg
      {...p}
      fill='none'
      viewBox='0 0 24 24'
      strokeWidth={2}
      stroke='currentColor'
    >
      <path
        strokeLinecap='round'
        strokeLinejoin='round'
        d='M8.25 4.5l7.5 7.5-7.5 7.5'
      />
    </svg>
  ),
  Building: p => (
    <svg
      {...p}
      fill='none'
      viewBox='0 0 24 24'
      strokeWidth={1.5}
      stroke='currentColor'
    >
      <path
        strokeLinecap='round'
        strokeLinejoin='round'
        d='M3.75 21h16.5M4.5 3h15M5.25 3v18m13.5-18v18M9 6.75h1.5m-1.5 3h1.5m-1.5 3h1.5m3-6H15m-1.5 3H15m-1.5 3H15M9 21v-3.375c0-.621.504-1.125 1.125-1.125h3.75c.621 0 1.125.504 1.125 1.125V21'
      />
    </svg>
  ),
  Location: p => (
    <svg
      {...p}
      fill='none'
      viewBox='0 0 24 24'
      strokeWidth={1.5}
      stroke='currentColor'
    >
      <path
        strokeLinecap='round'
        strokeLinejoin='round'
        d='M15 10.5a3 3 0 11-6 0 3 3 0 016 0z'
      />
      <path
        strokeLinecap='round'
        strokeLinejoin='round'
        d='M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z'
      />
    </svg>
  ),
  Users: p => (
    <svg
      {...p}
      fill='none'
      viewBox='0 0 24 24'
      strokeWidth={1.5}
      stroke='currentColor'
    >
      <path
        strokeLinecap='round'
        strokeLinejoin='round'
        d='M15 19.128a9.38 9.38 0 002.625.372 9.337 9.337 0 004.121-.952 4.125 4.125 0 00-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 018.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0111.964-3.07M12 6.375a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zm8.25 2.25a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z'
      />
    </svg>
  ),
  Upload: p => (
    <svg
      {...p}
      fill='none'
      viewBox='0 0 24 24'
      strokeWidth={1.5}
      stroke='currentColor'
    >
      <path
        strokeLinecap='round'
        strokeLinejoin='round'
        d='M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5m-13.5-9L12 3m0 0l4.5 4.5M12 3v13.5'
      />
    </svg>
  ),
  Enter: p => (
    <svg
      {...p}
      fill='none'
      viewBox='0 0 24 24'
      strokeWidth={2}
      stroke='currentColor'
    >
      <path
        strokeLinecap='round'
        strokeLinejoin='round'
        d='M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3'
      />
    </svg>
  ),
  Clock: p => (
    <svg
      {...p}
      fill='none'
      viewBox='0 0 24 24'
      strokeWidth={1.5}
      stroke='currentColor'
    >
      <path
        strokeLinecap='round'
        strokeLinejoin='round'
        d='M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z'
      />
    </svg>
  ),
  Phone: p => (
    <svg
      {...p}
      fill='none'
      viewBox='0 0 24 24'
      strokeWidth={1.5}
      stroke='currentColor'
    >
      <path
        strokeLinecap='round'
        strokeLinejoin='round'
        d='M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z'
      />
    </svg>
  ),
  Close: p => (
    <svg
      {...p}
      fill='none'
      viewBox='0 0 24 24'
      strokeWidth={2}
      stroke='currentColor'
    >
      <path
        strokeLinecap='round'
        strokeLinejoin='round'
        d='M6 18L18 6M6 6l12 12'
      />
    </svg>
  )
}

const API_BASE = process.env.REACT_APP_SOCKET_URL || 'http://localhost:5000'

// ── Shift time helpers ────────────────────────────────────────────────────────
/**
 * Convert "HH:MM" (24-hr) → "H:MM AM/PM"
 * Returns the original string if it cannot be parsed.
 */
function to12Hour (timeStr) {
  if (!timeStr) return null
  const [h, m] = timeStr.split(':').map(Number)
  if (isNaN(h) || isNaN(m)) return timeStr
  const period = h >= 12 ? 'PM' : 'AM'
  const hour = h % 12 || 12
  return `${hour}:${String(m).padStart(2, '0')} ${period}`
}

/**
 * Calculate total working hours between two "HH:MM" strings.
 * Handles overnight shifts (end < start).
 */
function workingHours (startStr, endStr) {
  if (!startStr || !endStr) return null
  const [sh, sm] = startStr.split(':').map(Number)
  const [eh, em] = endStr.split(':').map(Number)
  if (isNaN(sh) || isNaN(eh)) return null
  let totalMins = eh * 60 + em - (sh * 60 + sm)
  if (totalMins <= 0) totalMins += 24 * 60 // overnight shift
  const hrs = Math.floor(totalMins / 60)
  const mins = totalMins % 60
  return mins > 0 ? `${hrs}h ${mins}m` : `${hrs}h`
}

// ── Location type options ─────────────────────────────────────────────────────

// ── Site node: one Site (location) with its Departments. Add Department only. ──
const SiteNode = ({ site, orgId, tenantId, allDepartments, onChanged }) => {
  const [addingDept, setAddingDept] = useState(false)
  const [deptForm, setDeptForm] = useState({ name: '' })

  const departments = (allDepartments || []).filter(
    d => String(d.location_id) === String(site.id)
  )

  const handleAddDepartment = async e => {
    e.preventDefault()
    if (!deptForm.name.trim()) return
    try {
      await departmentApi.create(
        { name: deptForm.name.trim(), location_id: site.id, org_id: orgId },
        tenantId
      )
      toast.success('Department added')
      setDeptForm({ name: '' })
      setAddingDept(false)
      onChanged()
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to add department')
    }
  }

  const handleDeleteSite = async () => {
    if (!window.confirm(`Delete site "${site.name}" and its departments?`)) return
    try {
      await locationApi.delete(site.id, tenantId)
      toast.success('Site deleted')
      onChanged()
    } catch {
      toast.error('Failed to delete site')
    }
  }

  const handleDeleteDepartment = async dept => {
    if (!window.confirm(`Delete department "${dept.name}"?`)) return
    try {
      await departmentApi.delete(dept.id, tenantId)
      toast.success('Department deleted')
      onChanged()
    } catch {
      toast.error('Failed to delete department')
    }
  }

  return (
    <div className='border border-gray-100 rounded-lg mb-1.5 bg-white'>
      {/* SITE ROW */}
      <div className='flex items-center justify-between px-3 py-2.5 hover:bg-gray-50'>
        <div className='flex items-center gap-2'>
          <Icon.Location className='w-4 h-4 text-emerald-600' />
          <span className='text-sm font-medium text-gray-700'>{site.name}</span>
          <span className='text-xs bg-emerald-100 text-emerald-600 px-1.5 py-0.5 rounded'>
            Site
          </span>
        </div>
        <div className='flex items-center gap-1 text-gray-400'>
          <button
            title='Add department'
            onClick={() => { setAddingDept(o => !o); setDeptForm({ name: '' }) }}
            className='hover:text-green-600 p-0.5'
          >
            <Icon.Plus className='w-4 h-4' />
          </button>
          <button
            title='Delete site'
            onClick={handleDeleteSite}
            className='hover:text-red-500 p-0.5'
          >
            <Icon.Trash className='w-4 h-4' />
          </button>
        </div>
      </div>

      {/* ADD DEPARTMENT FORM */}
      {addingDept && (
        <form
          onSubmit={handleAddDepartment}
          className='flex gap-2 flex-wrap items-center border-l-2 border-green-300 bg-green-50/60 py-2 pr-3 pl-8'
        >
          <span className='text-[11px] text-green-700 font-medium w-full'>
            Department under <b>{site.name}</b>
          </span>
          <input
            autoFocus
            value={deptForm.name}
            onChange={e => setDeptForm({ name: e.target.value })}
            placeholder='Department name'
            className='flex-1 min-w-[120px] border border-green-300 rounded px-2 py-1 text-sm focus:outline-none focus:ring-1 focus:ring-green-400 bg-white'
          />
          <button type='submit' className='bg-green-700 text-white px-3 py-1 rounded text-sm'>
            Add
          </button>
          <button
            type='button'
            onClick={() => setAddingDept(false)}
            className='text-gray-400 px-2 text-sm'
          >
            Cancel
          </button>
        </form>
      )}

      {/* DEPARTMENTS under this site */}
      {departments.map(dep => (
        <div
          key={dep.id}
          className='flex items-center justify-between px-3 py-2 pl-8 hover:bg-gray-50'
        >
          <div className='flex items-center gap-2'>
            <svg
              className='w-3.5 h-3.5 text-indigo-400 flex-shrink-0'
              fill='none'
              viewBox='0 0 24 24'
              strokeWidth={1.8}
              stroke='currentColor'
            >
              <path
                strokeLinecap='round'
                strokeLinejoin='round'
                d='M2.25 21h19.5m-18-18v18m10.5-18v18m6-13.5V21M6.75 6.75h.75m-.75 3h.75m-.75 3h.75m3-6h.75m-.75 3h.75m-.75 3h.75M6.75 21v-3.375c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21M3 3h12m-.75 4.5H21m-3.75 3.75h.008v.008h-.008v-.008zm0 3h.008v.008h-.008v-.008zm0 3h.008v.008h-.008v-.008z'
              />
            </svg>
            <span className='text-sm text-gray-600'>{dep.name}</span>
            <span className='text-xs bg-indigo-50 text-indigo-500 px-1.5 py-0.5 rounded'>
              Department
            </span>
          </div>
          <button
            onClick={() => handleDeleteDepartment(dep)}
            className='text-gray-300 hover:text-red-500 p-0.5'
          >
            <Icon.Trash className='w-3.5 h-3.5' />
          </button>
        </div>
      ))}
      {departments.length === 0 && !addingDept && (
        <p className='text-[11px] text-gray-400 px-3 pb-2 pl-8'>
          No departments yet — use + to add one.
        </p>
      )}
    </div>
  )
}

// ── Expanded management panel (tabs: Org Structure | Users) ────────────────────
const OrgManagePanel = ({ org }) => {
  const { user } = useAuth()
  const [activeTab, setActiveTab] = useState('structure')
  const [subOrgs, setSubOrgs] = useState([])
  const [subOrgsLoaded, setSubOrgsLoaded] = useState(false)
  const [allLocations, setAllLocations] = useState([])
  const [allDepartments, setAllDepartments] = useState([])
  const [users, setUsers] = useState([])
  const [loadingOrgs, setLoadingOrgs] = useState(false)
  const [loadingUsers, setLoadingUsers] = useState(false)

  // Add site
  const [addingSite, setAddingSite] = useState(false)
  const [siteForm, setSiteForm] = useState({ name: '', location_type: 'Building' })

  // Add admin user
  const [addUser, setAddUser] = useState(false)
  const [addingUser, setAddingUser] = useState(false)
  const [userForm, setUserForm] = useState({
    full_name: '',
    email: '',
    role: 'admin',
  })

  const tenantId = org.tenant_id

  // Sites = locations attached directly to this organization
  const orgSites = (allLocations || []).filter(
    l => String(l.org_id || l.organization_id) === String(org.id) && !l.parent_id
  )

  const handleAddSite = async e => {
    e.preventDefault()
    if (!siteForm.name.trim()) return
    try {
      await locationApi.create(
        {
          name: siteForm.name.trim(),
          location_type: siteForm.location_type,
          org_id: org.id,
          parent_id: null,
        },
        tenantId
      )
      toast.success('Site added')
      setSiteForm({ name: '', location_type: 'Building' })
      setAddingSite(false)
      fetchSubOrgs()
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to add site')
    }
  }

  // Flatten nested location tree into a flat array
  const flattenLocations = locs => {
    const result = []
    const traverse = items => {
      if (!items) return
      items.forEach(l => {
        result.push(l)
        if (l.children) traverse(l.children)
      })
    }
    traverse(locs)
    return result
  }

  const fetchSubOrgs = useCallback(async () => {
    if (!tenantId) return
    // Only show the loading spinner on the very first fetch so that subsequent
    // refreshes (after add/delete) don't flash the loading state.
    if (!subOrgsLoaded) setLoadingOrgs(true)
    try {
      const [orgsRes, locsRes, departmentsRes] = await Promise.all([
        // Explicitly filter by parent_id === org.id so we only get
        // direct sub-divisions of this client org.
        organizationApi.getAll({ tenantId, parentId: org.id }),
        locationApi.getAll({ tenantId }),
        departmentApi.getAll({ tenantId })
      ])
      setSubOrgs(orgsRes.data?.data || orgsRes.data || [])
      setSubOrgsLoaded(true)
      setAllLocations(
        flattenLocations(locsRes.data?.data || locsRes.data || [])
      )
      setAllDepartments(departmentsRes.data?.data || departmentsRes.data || [])
    } catch {
      /* silent */
    } finally {
      setLoadingOrgs(false)
    }
  }, [tenantId, org.id, subOrgsLoaded])

  const fetchUsers = useCallback(async () => {
    if (!tenantId) return
    setLoadingUsers(true)
    try {
      const res = await userApi.getAll({ tenantId })
      setUsers(res.data?.data || res.data || [])
    } catch {
      /* silent */
    } finally {
      setLoadingUsers(false)
    }
  }, [tenantId])

  useEffect(() => {
    if (activeTab === 'structure') fetchSubOrgs()
    if (activeTab === 'users') {
      fetchUsers()
      // Also load subOrgs for grouping if not already fetched
      if (!subOrgsLoaded) fetchSubOrgs()
    }
  }, [activeTab, subOrgsLoaded, fetchSubOrgs, fetchUsers])

  const handleAddUser = async e => {
    e.preventDefault()
    if (!userForm.full_name.trim()) {
      toast.error('Full name is required')
      return
    }
    if (addingUser) return
    setAddingUser(true)
    try {
      const res = await userApi.createForOrg({
        ...userForm,
        tenant_id: tenantId,
        org_id: org.id,
      })
      // Use the server message so email failures are visible instead of silent
      toast.success(res.data?.message || `Invitation sent to ${userForm.email}`)
      setUserForm({ full_name: '', email: '', role: 'admin' })
      setAddUser(false)
      fetchUsers()
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to create user')
    } finally {
      setAddingUser(false)
    }
  }

  const TABS = [
    {
      id: 'structure',
      label: 'Org Structure',
      icon: <Icon.Building className='w-4 h-4' />
    },
    { id: 'users', label: 'Users', icon: <Icon.Users className='w-4 h-4' /> }
  ]

  return (
    <div className='bg-gray-50/60 px-5 py-4'>
      {/* Tab bar */}
      <div className='flex gap-1 mb-4 border-b border-gray-200'>
        {TABS.map(t => (
          <button
            key={t.id}
            onClick={() => setActiveTab(t.id)}
            className={`flex items-center gap-1.5 px-4 py-2 text-sm font-medium border-b-2 transition-colors ${
              activeTab === t.id
                ? 'border-blue-700 text-blue-700'
                : 'border-transparent text-gray-500 hover:text-gray-700'
            }`}
          >
            {t.icon} {t.label}
          </button>
        ))}
      </div>

      {/* ── Structure tab ─────────────────────────────────────────── */}
      {activeTab === 'structure' && (
        <div>
          {/* Root org node */}
          <div className='border border-blue-200 bg-blue-50 rounded-lg px-3 py-2.5 mb-3 flex items-center justify-between'>
            <div className='flex items-center gap-2'>
              <Icon.Building className='w-4 h-4 text-blue-600 flex-shrink-0' />
              <div>
                <p className='text-sm font-semibold text-blue-800'>
                  {org.company_name || org.name}
                </p>
                {org.public_id && (
                  <p className='text-[10px] font-mono text-blue-400 mt-0.5'>
                    {org.public_id}
                  </p>
                )}
              </div>
            </div>
            <span className='text-[10px] text-blue-500 bg-blue-100 border border-blue-200 rounded px-2 py-0.5 font-medium'>
              Organization
            </span>
          </div>

          {/* Sites header + Add site */}
          <div className='flex justify-between items-center mb-2 pl-4 border-l-2 border-dashed border-blue-200'>
            <span className='text-xs text-gray-500 font-medium uppercase tracking-wide'>
              Sites
            </span>
            <button
              onClick={() => { setAddingSite(s => !s); setSiteForm({ name: '', location_type: 'Building' }) }}
              className='flex items-center gap-1 text-sm text-blue-700 hover:text-blue-900 font-medium'
            >
              <Icon.Plus className='w-4 h-4' /> Add Site
            </button>
          </div>

          {addingSite && (
            <form
              onSubmit={handleAddSite}
              className='flex gap-2 mb-3 ml-4 flex-wrap'
            >
              <input
                autoFocus
                value={siteForm.name}
                onChange={e => setSiteForm({ ...siteForm, name: e.target.value })}
                placeholder='Site name'
                className='flex-1 min-w-[150px] border border-gray-200 rounded px-3 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400'
              />
              <button
                type='button'
                onClick={() => setAddingSite(false)}
                className='text-gray-400 px-2 text-sm'
              >
                Cancel
              </button>
            </form>
          )}

          <div className='pl-4 border-l-2 border-dashed border-blue-200'>
            {loadingOrgs ? (
              <p className='text-sm text-gray-400 py-4 text-center'>Loading…</p>
            ) : orgSites.length === 0 ? (
              <p className='text-sm text-gray-400 text-center py-4'>
                No sites yet. Use “Add Site” to create one.
              </p>
            ) : (
              orgSites.map(site => (
                <SiteNode
                  key={site.id}
                  site={site}
                  orgId={org.id}
                  tenantId={tenantId}
                  allDepartments={allDepartments}
                  onChanged={fetchSubOrgs}
                />
              ))
            )}
          </div>
        </div>
      )}

      {/* ── Users tab ────────────────────────────────────────────── */}
      {activeTab === 'users' && (
        <div>
          <div className='flex justify-between items-center mb-3'>
            <span className='text-xs text-gray-500 font-medium uppercase tracking-wide'>
              Users
            </span>
            <button
              onClick={() => setAddUser(!addUser)}
              className='flex items-center gap-1 text-sm text-blue-700 hover:text-blue-900 font-medium'
            >
              <Icon.Plus className='w-4 h-4' /> Add User
            </button>
          </div>

          {addUser && (
            <form
              onSubmit={handleAddUser}
              className='grid grid-cols-1 sm:grid-cols-2 gap-2 mb-4 p-3 border border-blue-100 bg-blue-50/40 rounded-lg'
            >
              <input
                required
                value={userForm.full_name}
                onChange={e =>
                  setUserForm({ ...userForm, full_name: e.target.value })
                }
                placeholder='Full name'
                className='border border-gray-200 rounded px-3 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400'
              />
              <input
                type='email'
                required
                value={userForm.email}
                onChange={e =>
                  setUserForm({ ...userForm, email: e.target.value })
                }
                placeholder='Email address'
                className='border border-gray-200 rounded px-3 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400'
              />
              <select
                value={userForm.role}
                onChange={e =>
                  setUserForm({ ...userForm, role: e.target.value })
                }
                className='border border-gray-200 rounded px-3 py-1.5 text-sm focus:outline-none'
              >
                <option value='admin'>Admin</option>
                <option value='operator'>Operator</option>
                <option value='viewer'>Viewer</option>
              </select>
              <div className='sm:col-span-2 flex gap-2 justify-end'>
                <button
                  type='button'
                  onClick={() => setAddUser(false)}
                  className='text-gray-500 text-sm px-3 py-1.5 border border-gray-200 rounded hover:bg-gray-50'
                >
                  Cancel
                </button>
                <button
                  type='submit'
                  disabled={addingUser}
                  className='bg-blue-700 text-white px-4 py-1.5 rounded text-sm disabled:opacity-60 disabled:cursor-not-allowed'
                >
                  {addingUser ? 'Sending...' : 'Send Invitation'}
                </button>
              </div>
            </form>
          )}

          {loadingUsers ? (
            <p className='text-sm text-gray-400 py-4 text-center'>Loading…</p>
          ) : users.filter(u => u.role !== 'super_admin' && u.org_id).length ===
            0 ? (
            <p className='text-sm text-gray-400 text-center py-4'>
              No users yet.
            </p>
          ) : (
            (() => {
              // Only show users that belong to a known org (root or sub-org); skip unassigned
              const knownOrgIds = new Set([org.id, ...subOrgs.map(o => o.id)])
              const visibleUsers = users.filter(
                u =>
                  u.role !== 'super_admin' &&
                  u.org_id &&
                  knownOrgIds.has(u.org_id)
              )

              // Build groups: root org members, then each direct sub-org
              const rootMembers = visibleUsers.filter(u => u.org_id === org.id)
              const subOrgGroups = subOrgs
                .map(so => ({
                  org: so,
                  members: visibleUsers.filter(u => u.org_id === so.id)
                }))
                .filter(g => g.members.length > 0)

              const UserRow = ({ u }) => (
                <div
                  key={u.id}
                  className='flex items-center justify-between bg-white border border-gray-100 rounded-lg px-3 py-2'
                >
                  <div>
                    <p className='text-sm font-medium text-gray-800'>
                      {u.full_name || u.email}
                    </p>
                    <p className='text-xs text-gray-400'>{u.email}</p>
                  </div>
                  <span
                    className={`text-xs font-medium px-2 py-0.5 rounded-full ${
                      u.role === 'admin'
                        ? 'bg-blue-100 text-blue-700'
                        : u.role === 'operator'
                        ? 'bg-orange-100 text-orange-700'
                        : 'bg-gray-100 text-gray-600'
                    }`}
                  >
                    {u.role}
                  </span>
                </div>
              )

              const SectionHeader = ({ label, count }) => (
                <div className='flex items-center gap-2 mt-3 mb-1.5'>
                  <span className='text-xs font-semibold text-gray-500 uppercase tracking-wide'>
                    {label}
                  </span>
                  <span className='text-xs bg-gray-100 text-gray-500 px-1.5 py-0.5 rounded-full'>
                    {count}
                  </span>
                </div>
              )

              return (
                <div className='space-y-0.5'>
                  {rootMembers.length > 0 && (
                    <div>
                      <SectionHeader
                        label={org.name}
                        count={rootMembers.length}
                      />
                      <div className='space-y-1.5'>
                        {rootMembers.map(u => (
                          <UserRow key={u.id} u={u} />
                        ))}
                      </div>
                    </div>
                  )}
                  {subOrgGroups.map(({ org: so, members }) => (
                    <div key={so.id}>
                      <SectionHeader label={so.name} count={members.length} />
                      <div className='space-y-1.5'>
                        {members.map(u => (
                          <UserRow key={u.id} u={u} />
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
              )
            })()
          )}
        </div>
      )}
    </div>
  )
}

// ── Individual org card ───────────────────────────────────────────────────────
const OrgCard = ({ org, onEdit, onDeleted, onEnter, onManage, onToggleActive }) => {
  const logoUrl = org.logo_path
    ? `${API_BASE}/api/organizations/${org.id}/logo`
    : null

  // Default to active when the field is absent (older payloads)
  const isActive = org.is_active !== false

  return (
    <div className='bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden'>
      {/* Card header */}
      <div className='p-5'>
        <div className='flex items-start gap-4'>
          {/* Logo */}
          <div className='w-14 h-14 rounded-lg bg-gray-100 border border-gray-200 flex items-center justify-center flex-shrink-0 overflow-hidden'>
            {logoUrl ? (
              <img
                src={logoUrl}
                alt={org.company_name}
                className='w-full h-full object-cover'
              />
            ) : (
              <Icon.Building className='w-7 h-7 text-gray-400' />
            )}
          </div>

          {/* Info */}
          <div className='flex-1 min-w-0'>
            <div className='flex items-center gap-2'>
              <h3 className='font-bold text-gray-800 text-base truncate'>
                {org.company_name || org.name}
              </h3>
              <span
                className={`text-[10px] font-semibold px-2 py-0.5 rounded-full border flex-shrink-0 ${
                  isActive
                    ? 'bg-green-50 text-green-700 border-green-200'
                    : 'bg-red-50 text-red-700 border-red-200'
                }`}
              >
                {isActive ? 'Active' : 'Inactive'}
              </span>
            </div>
            <div className='mt-2 flex flex-wrap gap-x-4 gap-y-1 text-xs text-gray-500'>
              {org.phone_number && (
                <span className='flex items-center gap-1'>
                  <Icon.Phone className='w-3.5 h-3.5' /> {org.phone_number}
                </span>
              )}
              {org.shifts?.length > 0
                ? org.shifts.map(s => (
                    <span key={s.id} className='flex items-center gap-1'>
                      <Icon.Clock className='w-3.5 h-3.5' />
                      <span className='font-medium'>{s.name}:</span>
                      {to12Hour(s.start)} – {to12Hour(s.end)}
                    </span>
                  ))
                : (org.shift_start_time || org.shift_end_time) && (
                    <span className='flex items-center gap-1'>
                      <Icon.Clock className='w-3.5 h-3.5' />
                      {to12Hour(org.shift_start_time) || '—'} –{' '}
                      {to12Hour(org.shift_end_time) || '—'}
                      {workingHours(org.shift_start_time, org.shift_end_time) && (
                        <span className='ml-1 text-[10px] bg-blue-100 text-blue-700 px-1.5 py-0.5 rounded-full font-medium'>
                          {workingHours(org.shift_start_time, org.shift_end_time)}
                        </span>
                      )}
                    </span>
                  )}
            </div>
            {org.address && (
              <p className='text-xs text-gray-400 mt-1 truncate'>
                {org.address}
              </p>
            )}
          </div>
        </div>

        {/* Actions */}
        <div className='flex items-center justify-between mt-4 pt-3 border-t border-gray-100'>
          <div className='flex gap-2'>
            <button
              onClick={() => onEnter(org)}
              className='flex items-center gap-1.5 bg-blue-800 hover:bg-blue-900 text-white text-sm font-medium px-4 py-1.5 rounded-lg'
            >
              <Icon.Enter className='w-4 h-4' /> Enter
            </button>
            <button
              onClick={() => onManage(org)}
              className='flex items-center gap-1.5 border border-gray-200 text-gray-600 hover:bg-gray-50 text-sm font-medium px-4 py-1.5 rounded-lg transition-colors'
            >
              Manage
            </button>
          </div>

          <div className='flex items-center gap-2'>
            {/* Active / Inactive toggle */}
            <button
              onClick={() => onToggleActive(org)}
              title={isActive ? 'Deactivate organisation' : 'Activate organisation'}
              className='flex items-center gap-1.5 group'
            >
              <span
                className={`relative inline-flex h-5 w-9 items-center rounded-full transition-colors ${
                  isActive ? 'bg-green-500' : 'bg-gray-300'
                }`}
              >
                <span
                  className={`inline-block h-4 w-4 transform rounded-full bg-white shadow transition-transform ${
                    isActive ? 'translate-x-4' : 'translate-x-1'
                  }`}
                />
              </span>
            </button>
            <button
              onClick={() => onEdit(org)}
              className='p-1.5 text-gray-400 hover:text-blue-600 rounded-md hover:bg-blue-50'
              title='Edit details'
            >
              <Icon.Pencil className='w-4 h-4' />
            </button>
            <button
              onClick={() => onDeleted(org)}
              className='p-1.5 text-gray-400 hover:text-red-500 rounded-md hover:bg-red-50'
              title='Delete'
            >
              <Icon.Trash className='w-4 h-4' />
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

// ── 12-hour Time Picker ───────────────────────────────────────────────────────
/**
 * Controlled 12-hour AM/PM time picker.
 * Props:
 *   value    – "HH:MM" in 24-hour format (or "")
 *   onChange – called with "HH:MM" 24-hour string
 *   label    – optional label text
 */
const TimePicker12h = ({ value, onChange, label }) => {
  // Parse incoming 24-hour value → {hour12, minute, period}
  const parse = v => {
    if (!v) return { hour12: '', minute: '00', period: 'AM' }
    const [h, m] = v.split(':').map(Number)
    const period = h >= 12 ? 'PM' : 'AM'
    const hour12 = h % 12 === 0 ? 12 : h % 12
    return {
      hour12: String(hour12),
      minute: String(m).padStart(2, '0'),
      period
    }
  }

  const { hour12, minute, period } = parse(value)

  // Convert back to 24-hour "HH:MM" and call onChange
  const emit = (h12, min, per) => {
    if (!h12) {
      onChange('')
      return
    }
    let h = parseInt(h12, 10)
    if (per === 'AM') {
      if (h === 12) h = 0
    } else {
      if (h !== 12) h += 12
    }
    onChange(`${String(h).padStart(2, '0')}:${min}`)
  }

  const hours = Array.from({ length: 12 }, (_, i) => i + 1)
  const minutes = Array.from({ length: 60 }, (_, i) =>
    String(i).padStart(2, '0')
  )

  const selectCls =
    'border border-gray-200 rounded-lg text-sm text-gray-700 bg-white ' +
    'focus:outline-none focus:ring-2 focus:ring-blue-500 cursor-pointer'

  return (
    <div>
      {label && (
        <label className='block text-xs text-gray-500 mb-1.5 font-medium'>
          {label}
        </label>
      )}
      <div className='flex items-center gap-1.5'>
        {/* Hour */}
        <select
          value={hour12}
          onChange={e => emit(e.target.value, minute, period)}
          className={`${selectCls} px-2 py-2 w-16 text-center`}
        >
          <option value=''>HH</option>
          {hours.map(h => (
            <option key={h} value={h}>
              {String(h).padStart(2, '0')}
            </option>
          ))}
        </select>

        <span className='text-gray-400 font-bold text-sm'>:</span>

        {/* Minute */}
        <select
          value={minute}
          onChange={e => emit(hour12, e.target.value, period)}
          className={`${selectCls} px-2 py-2 w-16 text-center`}
        >
          {minutes.map(m => (
            <option key={m} value={m}>
              {m}
            </option>
          ))}
        </select>

        {/* AM / PM toggle */}
        <div className='flex rounded-lg overflow-hidden border border-gray-200 ml-1'>
          {['AM', 'PM'].map(p => (
            <button
              key={p}
              type='button'
              onClick={() => emit(hour12, minute, p)}
              className={`px-3 py-2 text-xs font-semibold transition-colors ${
                period === p
                  ? 'bg-blue-800 text-white'
                  : 'bg-white text-gray-500 hover:bg-gray-50'
              }`}
            >
              {p}
            </button>
          ))}
        </div>
      </div>

      {/* Live preview */}
      {value && (
        <p className='text-[11px] text-blue-600 mt-1.5 font-medium'>
          {to12Hour(value)}
        </p>
      )}
    </div>
  )
}

// ── Create / Edit modal ───────────────────────────────────────────────────────
const EMPTY_FORM = {
  company_name: '',
  phone_number: '',
  address: '',
  shifts: []   // user-defined shifts (1–3), each with its own name + start + end
}

const EMPTY_SHIFT = id => ({ id, name: `Shift ${id}`, start: '', end: '' })

const OrgFormModal = ({ isOpen, onClose, onSaved, editOrg }) => {
  const { login } = useAuth()
  const [form, setForm] = useState(EMPTY_FORM)
  const [logoFile, setLogoFile] = useState(null)
  const [logoPreview, setLogoPreview] = useState(null)
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState('')
  const fileRef = useRef()

  useEffect(() => {
    if (isOpen) {
      if (editOrg) {
        const legacyShifts =
          editOrg.shift_start_time && editOrg.shift_end_time && !editOrg.shifts?.length
            ? [{ id: 1, name: 'Shift 1', start: editOrg.shift_start_time, end: editOrg.shift_end_time }]
            : []
        setForm({
          company_name: editOrg.company_name || '',
          phone_number: editOrg.phone_number || '',
          address: editOrg.address || '',
          shifts: editOrg.shifts?.length ? editOrg.shifts : legacyShifts
        })
        setLogoPreview(
          editOrg.logo_path
            ? `${API_BASE}/api/organizations/${editOrg.id}/logo`
            : null
        )
      } else {
        setForm(EMPTY_FORM)
        setLogoPreview(null)
      }
      setLogoFile(null)
      setError('')
    }
  }, [isOpen, editOrg])

  const handleLogoChange = e => {
    const file = e.target.files[0]
    if (!file) return
    setLogoFile(file)
    setLogoPreview(URL.createObjectURL(file))
  }

  const handleSubmit = async e => {
    e.preventDefault()
    if (!form.company_name.trim()) {
      setError('Company name is required')
      return
    }
    setSaving(true)
    setError('')

    try {
      let orgId

      // Keep the legacy start/end columns in sync with the first/last shift so
      // the report's day boundary (first shift start) resolves correctly.
      const ordered = [...form.shifts].filter(s => s.start && s.end)
      const payload = {
        company_name: form.company_name,
        phone_number: form.phone_number,
        address: form.address,
        shifts: form.shifts,
        shift_start_time: ordered[0]?.start || null,
        shift_end_time: ordered[ordered.length - 1]?.end || null
      }

      if (editOrg) {
        const res = await organizationApi.updateClient(editOrg.id, payload)
        orgId = editOrg.id
        // Handle possible first-org token refresh
        if (res.data.data?.tokens) login(res.data.data.tokens)
      } else {
        const res = await organizationApi.createClient(payload)
        orgId = res.data.data?.org?.id
        if (res.data.data?.tokens) login(res.data.data.tokens)
      }

      // Upload logo if selected
      if (logoFile && orgId) {
        const fd = new FormData()
        fd.append('logo', logoFile)
        await organizationApi.uploadLogo(orgId, fd)
      }

      toast.success(editOrg ? 'Organisation updated' : 'Organisation created')
      onSaved()
      onClose()
    } catch (err) {
      setError(err.response?.data?.message || 'Something went wrong')
    } finally {
      setSaving(false)
    }
  }

  if (!isOpen) return null

  return (
    <div className='fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4'>
      <div
        className='bg-white rounded-2xl shadow-2xl w-full max-w-lg flex flex-col'
        style={{ maxHeight: '90vh' }}
      >
        {/* Header */}
        <div className='flex items-center justify-between px-6 py-4 border-b border-gray-100 bg-gray-50 flex-shrink-0 rounded-t-2xl'>
          <h2 className='text-lg font-bold text-gray-800'>
            {editOrg ? 'Edit Organisation' : 'Create New Organisation'}
          </h2>
          <button
            onClick={onClose}
            className='text-gray-400 hover:text-gray-600'
          >
            <Icon.Close className='w-5 h-5' />
          </button>
        </div>

        <form
          onSubmit={handleSubmit}
          className='p-6 space-y-4 overflow-y-auto flex-1'
        >
          {error && (
            <div className='bg-red-50 border border-red-200 text-red-700 text-sm px-3 py-2 rounded-lg'>
              {error}
            </div>
          )}

          {/* Logo upload */}
          <div className='flex items-center gap-4'>
            <div
              onClick={() => fileRef.current.click()}
              className='w-16 h-16 rounded-xl border-2 border-dashed border-gray-200 flex items-center justify-center cursor-pointer hover:border-blue-400 overflow-hidden bg-gray-50 flex-shrink-0'
            >
              {logoPreview ? (
                <img
                  src={logoPreview}
                  alt='logo preview'
                  className='w-full h-full object-cover'
                />
              ) : (
                <Icon.Upload className='w-6 h-6 text-gray-400' />
              )}
            </div>
            <div>
              <p className='text-sm font-medium text-gray-700'>Company Logo</p>
              <p className='text-xs text-gray-400'>
                Click to upload (PNG, JPG, SVG)
              </p>
              <input
                ref={fileRef}
                type='file'
                accept='image/*'
                className='hidden'
                onChange={handleLogoChange}
              />
            </div>
          </div>

          {/* Company Name */}
          <div>
            <label className='block text-sm font-medium text-gray-700 mb-1'>
              Company Name *
            </label>
            <input
              type='text'
              required
              value={form.company_name}
              onChange={e => setForm({ ...form, company_name: e.target.value })}
              placeholder='e.g. KPR Groups'
              className='w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500'
            />
          </div>

          {/* Phone */}
          <div>
            <label className='block text-sm font-medium text-gray-700 mb-1'>
              Phone Number
            </label>
            <input
              type='tel'
              value={form.phone_number}
              onChange={e => setForm({ ...form, phone_number: e.target.value })}
              placeholder='+91 98765 43210'
              className='w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500'
            />
          </div>

          {/* Address */}
          <div>
            <label className='block text-sm font-medium text-gray-700 mb-1'>
              Address
            </label>
            <textarea
              rows={2}
              value={form.address}
              onChange={e => setForm({ ...form, address: e.target.value })}
              placeholder='123 Industrial Area, Coimbatore'
              className='w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 resize-none'
            />
          </div>

          {/* Shifts — added manually (a company may run 1, 2 or 3 shifts) */}
          <div>
            <div className='flex items-center justify-between mb-2'>
              <label className='text-sm font-medium text-gray-700'>Shift Hours</label>
              <button
                type='button'
                onClick={() => setForm(f => ({
                  ...f,
                  shifts: [...f.shifts, EMPTY_SHIFT(f.shifts.length + 1)]
                }))}
                className='flex items-center gap-1 text-xs text-blue-700 font-semibold hover:underline'
              >
                <Icon.Plus className='w-3.5 h-3.5' /> Add Shift
              </button>
            </div>
            {form.shifts.length === 0 && (
              <p className='text-xs text-gray-400 italic'>
                No shifts configured — click "Add Shift" to add one.
              </p>
            )}
            <div className='space-y-2'>
              {form.shifts.map((s, i) => (
                <div key={s.id} className='border border-gray-100 rounded-xl p-3 bg-gray-50 space-y-2.5'>
                  {/* Name row */}
                  <div className='flex items-center gap-2'>
                    <input
                      value={s.name}
                      onChange={e => setForm(f => ({ ...f, shifts: f.shifts.map((x, j) => j === i ? { ...x, name: e.target.value } : x) }))}
                      placeholder='Shift name'
                      className='flex-1 border border-gray-200 rounded-lg px-3 py-1.5 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-blue-500'
                    />
                    <button
                      type='button'
                      onClick={() => setForm(f => ({ ...f, shifts: f.shifts.filter((_, j) => j !== i) }))}
                      className='text-gray-400 hover:text-red-500 flex-shrink-0'
                    >
                      <Icon.Close className='w-4 h-4' />
                    </button>
                  </div>
                  {/* Time rows */}
                  <div className='space-y-2'>
                    <div className='flex items-center gap-3'>
                      <span className='text-xs font-medium text-gray-500 w-10 flex-shrink-0'>Start</span>
                      <TimePicker12h
                        label=''
                        value={s.start}
                        onChange={v => setForm(f => ({ ...f, shifts: f.shifts.map((x, j) => j === i ? { ...x, start: v } : x) }))}
                      />
                    </div>
                    <div className='flex items-center gap-3'>
                      <span className='text-xs font-medium text-gray-500 w-10 flex-shrink-0'>End</span>
                      <TimePicker12h
                        label=''
                        value={s.end}
                        onChange={v => setForm(f => ({ ...f, shifts: f.shifts.map((x, j) => j === i ? { ...x, end: v } : x) }))}
                      />
                    </div>
                  </div>
                  {s.start && s.end && workingHours(s.start, s.end) && (
                    <p className='text-xs text-blue-600 font-medium flex items-center gap-1'>
                      <Icon.Clock className='w-3 h-3' />
                      {workingHours(s.start, s.end)}
                    </p>
                  )}
                </div>
              ))}
            </div>
          </div>

          {/* Footer */}
          <div className='flex gap-3 pt-2'>
            <button
              type='button'
              onClick={onClose}
              className='flex-1 border border-gray-300 text-gray-700 py-2 rounded-lg text-sm font-medium hover:bg-gray-50'
            >
              Cancel
            </button>
            <button
              type='submit'
              disabled={saving}
              className='flex-1 bg-blue-800 text-white py-2 rounded-lg text-sm font-medium hover:bg-blue-900 disabled:opacity-60'
            >
              {saving
                ? 'Saving…'
                : editOrg
                ? 'Save Changes'
                : 'Create Organisation'}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

// ── Manage popup modal ────────────────────────────────────────────────────────
const OrgManageModal = ({ org, onClose }) => {
  // Close on backdrop click
  const handleBackdrop = e => {
    if (e.target === e.currentTarget) onClose()
  }

  // Close on Escape key
  useEffect(() => {
    const handler = e => {
      if (e.key === 'Escape') onClose()
    }
    document.addEventListener('keydown', handler)
    return () => document.removeEventListener('keydown', handler)
  }, [onClose])

  return (
    <div
      className='fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm px-4'
      onClick={handleBackdrop}
    >
      <div className='bg-white rounded-2xl shadow-2xl w-full max-w-2xl max-h-[90vh] flex flex-col overflow-hidden'>
        {/* Modal header */}
        <div className='flex items-center justify-between px-6 py-4 border-b border-gray-100 flex-shrink-0'>
          <div>
            <h2 className='text-base font-bold text-gray-800'>
              {org.company_name || org.name}
            </h2>
          </div>
          <button
            onClick={onClose}
            className='text-gray-400 hover:text-gray-600 p-1 rounded-md hover:bg-gray-100'
          >
            <Icon.Close className='w-5 h-5' />
          </button>
        </div>

        {/* Scrollable panel content */}
        <div className='flex-1 overflow-y-auto'>
          <OrgManagePanel org={org} />
        </div>
      </div>
    </div>
  )
}

// ── Main Super Admin page ─────────────────────────────────────────────────────
export default function TenantManagement () {
  const { logout, selectTenant, login } = useAuth()
  const navigate = useNavigate()

  const [orgs, setOrgs] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [editingOrg, setEditingOrg] = useState(null)
  const [managingOrg, setManagingOrg] = useState(null)

  const fetchOrgs = useCallback(async () => {
    setIsLoading(true)
    try {
      const res = await organizationApi.getClients()
      setOrgs(res.data.data || [])
    } catch (err) {
      const status = err?.response?.status
      if (status === 403 || status === 401) {
        // JWT role mismatch (stale token) — force re-login so the
        // auto-upgrade logic in login_user can issue a fresh super_admin token.
        toast.error('Session expired. Please log in again.')
        setTimeout(() => {
          window.dispatchEvent(new CustomEvent('auth:force-logout'))
        }, 1500)
      } else {
        toast.error('Failed to load organizations')
      }
    } finally {
      setIsLoading(false)
    }
  }, [])

  useEffect(() => {
    fetchOrgs()
  }, [fetchOrgs])

  const handleEnter = org => {
    selectTenant({ id: org.tenant_id, name: org.company_name || org.name })
    navigate('/dashboard')
  }

  const handleDelete = async org => {
    if (
      !window.confirm(
        `Delete "${org.company_name || org.name}" and ALL its data?`
      )
    )
      return

    // Optimistic removal — card disappears immediately so the UI feels instant
    setOrgs(prev => prev.filter(o => o.id !== org.id))

    try {
      await organizationApi.deleteClient(org.id)
      toast.success('Organisation deleted')
      // Re-fetch to sync with server (catches any edge-cases)
      fetchOrgs()
    } catch {
      toast.error('Failed to delete')
      // Restore the list on failure
      fetchOrgs()
    }
  }

  const handleToggleActive = async org => {
    const next = org.is_active === false // currently inactive → activating

    // Optimistic update
    setOrgs(prev =>
      prev.map(o => (o.id === org.id ? { ...o, is_active: next } : o))
    )
    try {
      await organizationApi.setActive(org.id, next)
      toast.success(next ? 'Organisation activated' : 'Organisation deactivated')
    } catch {
      toast.error('Failed to update status')
      // Revert on failure
      setOrgs(prev =>
        prev.map(o => (o.id === org.id ? { ...o, is_active: !next } : o))
      )
    }
  }

  const handleLogout = async () => {
    await logout()
    navigate('/')
  }

  return (
    <div className='min-h-screen bg-[#f8fafc] font-sans'>
      <Toaster position='top-right' />

      {/* Top bar */}
      <header className='h-16 bg-white border-b border-gray-200 flex items-center justify-between px-8 sticky top-0 z-10 shadow-sm'>
        <div className='flex items-center gap-3'>
          <span className='text-xl font-bold text-gray-800'>QEDGE</span>
          <span className='text-xs bg-blue-100 text-blue-700 font-semibold px-2 py-0.5 rounded-full'>
            Super Admin
          </span>
        </div>
        <div className='flex gap-3'>
          <button
            onClick={() => {
              setEditingOrg(null)
              setIsModalOpen(true)
            }}
            className='flex items-center gap-2 bg-blue-800 hover:bg-blue-900 text-white text-sm font-medium px-5 py-2 rounded-lg shadow-sm'
          >
            <Icon.Plus className='w-4 h-4' /> Create Organisation
          </button>
          <button
            onClick={handleLogout}
            className='border border-gray-200 text-gray-600 hover:bg-gray-100 text-sm px-4 py-2 rounded-lg'
          >
            Logout
          </button>
        </div>
      </header>

      {/* Page content */}
      <main className='max-w-6xl mx-auto px-6 py-8'>
        <div className='mb-6'>
          <h1 className='text-2xl font-bold text-gray-800'>
            Organisation Management
          </h1>
          <p className='text-sm text-gray-500 mt-1'>
            Create and manage client organisations, their structure, locations
            and users.
          </p>
        </div>

        {isLoading ? (
          <div className='flex justify-center py-20 text-gray-400'>
            Loading organisations…
          </div>
        ) : orgs.length === 0 ? (
          <div className='text-center py-20 border-2 border-dashed border-gray-200 rounded-xl'>
            <Icon.Building className='w-12 h-12 text-gray-300 mx-auto mb-3' />
            <p className='text-gray-500 mb-4'>No organisations yet.</p>
            <button
              onClick={() => {
                setEditingOrg(null)
                setIsModalOpen(true)
              }}
              className='bg-blue-800 text-white px-6 py-2.5 rounded-lg text-sm font-medium hover:bg-blue-900'
            >
              Create your first organisation
            </button>
          </div>
        ) : (
          <div className='grid grid-cols-1 lg:grid-cols-2 gap-5'>
            {orgs.map(org => (
              <OrgCard
                key={org.id}
                org={org}
                onEdit={o => {
                  setEditingOrg(o)
                  setIsModalOpen(true)
                }}
                onDeleted={handleDelete}
                onEnter={handleEnter}
                onManage={o => setManagingOrg(o)}
                onToggleActive={handleToggleActive}
              />
            ))}
          </div>
        )}
      </main>

      <OrgFormModal
        isOpen={isModalOpen}
        onClose={() => {
          setIsModalOpen(false)
          setEditingOrg(null)
        }}
        onSaved={fetchOrgs}
        editOrg={editingOrg}
      />

      {managingOrg && (
        <OrgManageModal
          org={managingOrg}
          onClose={() => setManagingOrg(null)}
        />
      )}
    </div>
  )
}
